import styled from 'styled-components';

interface ITooltipButtonStyles {
  color?: string;
  bottom?: string;
  left?: string;
  width?: string;
  height?: string;
  maxWidth?: string;
  padding?: string;
  maxHeight?: string;
  areaRight?: string;
  areaBottom?: string;
  border?: string;
  overflow?: string;
  boxShadow?: string;
}


export const TooltipArea = styled.div`
  padding: 0;
  position: absolute;
  z-index: 99999;
  right: ${({ areaRight }: ITooltipButtonStyles) => areaRight || "95%"};
  bottom: ${({ areaBottom }: ITooltipButtonStyles) => areaBottom ? areaBottom : "60%"};
  border: ${({ border } : ITooltipButtonStyles) => border ? border : ''};
  border-radius: 8px;
  background-color: #FFF;
`

export const Tooltip = styled.div`
  justify-content: center;
  align-items: center;

  //position: absolute;
  left: ${({ left }: ITooltipButtonStyles) => left ? left : "-50%"};
  bottom: ${({ bottom }: ITooltipButtonStyles) => bottom ? bottom : "52%"};
  white-space: pre-wrap;
  z-index: 20;
  color: ${({ color }: ITooltipButtonStyles) => color ? color : "#293E52"};
  width: ${({ width }: ITooltipButtonStyles) => width ? width : "162px"};
  max-width: ${({ maxWidth }: ITooltipButtonStyles) => maxWidth ? maxWidth : "502px"};
  height: ${({ height }: ITooltipButtonStyles) => height ? height : "auto"};
  max-height: ${({ maxHeight }: ITooltipButtonStyles) => maxHeight ? maxHeight : ""};
  padding: ${({ padding }: ITooltipButtonStyles) => padding ? padding : "16px"};
  overflow: ${({ overflow }: ITooltipButtonStyles) => overflow ? overflow : ''};
  box-sizing: border-box;
  box-shadow: ${({boxShadow}: ITooltipButtonStyles) => boxShadow ? boxShadow : '0 4px 23px rgba(0, 0, 0, 0.1)'};

  font-size: 12px;
  line-height: 14px;
  letter-spacing: -0.015em;
  text-align: center;
  user-select: none;
`